"use client";

import dynamic from "next/dynamic";
import type { ReactNode } from "react";

/**
 * Lenis only loads on the client and stays out of the server layout bundle.
 * Children always render (SSR + client) so React hydration stays in sync.
 * Only the Lenis initialization (effects) is client-only via dynamic import.
 */
const LenisInit = dynamic(
  () => import("@/lib/lenis-provider").then((m) => m.LenisInitializer),
  { ssr: false }
);

export function DynamicLenisProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <LenisInit />
    </>
  );
}
